import { render, staticRenderFns } from "./CreateEducationalInstitute.vue?vue&type=template&id=46cefc08"
import script from "./CreateEducationalInstitute.vue?vue&type=script&lang=js"
export * from "./CreateEducationalInstitute.vue?vue&type=script&lang=js"
import style0 from "./CreateEducationalInstitute.vue?vue&type=style&index=0&id=46cefc08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports